:host([variant="default"]) {
    @include font(light);

    font-size: var(--ux-text-font-size-normal);
    line-height: var(--ux-text-line-height-normal);

    @media (min-width: $bp-xl) {
        font-size: $size-text-normal;
        line-height: $line-height-normal;
    }

    display: block;
    margin-block-start: 1em;
    margin-block-end: 1em;
}

:host([variant="title"]) {
    @include font(regular);
    font-size: $size-title-normal;
}

:host([variant="teaser"]) {
    @include font(bold);

    color: $color-black;
    font-size: $size-text-normal;
    line-height: 26px;

    @media only screen and (width >=1024px) {
        font-size: $size-text-normal-plus;
    }
}


:host([strong]) {
    @include font(bold);
    color: $color-gray-copy;
}

:host([light]) {
    @include font(light);
}

:host([big]) {
    font-size: $size-title-regular;
}

:host([variant='tiny']) {
    font-size: $size-text-small;
    line-height: 1.6;
}